<style>
.instruction-box {
  background-color: #fff7f7;
  border: 1px solid #f2c2c2;
  border-radius: 8px;
  text-align: center;
}

.note-text {
  color: #6b0000;
  font-size: 14px;
}
</style>
<style scoped>
@media (max-width: 320px) and (max-height: 658px){
  .side_bar { display: none !important; }
  .slot_section { flex: 0 0 70% !important; max-width: 100% !important; }
}
</style>
<template>
    <Header />
    <div class="container custom_container">
        <div class="row">

            <div class="col-lg-3 col-md-4 side_bar">
                <div class="sidebar-wrapper p-3">
    
                    <!-- Appointment Summary -->
                    <div v-if="sideBarApplicantData" class="appointment-summary mb-4">
                    <h6 style="color: #C8102E;"><b>Appointment Details</b></h6>
                    <ul class="list-unstyled mb-0">
                        <li class="mb-2">
                        <strong>Booking ID:</strong> <span>{{ sideBarApplicantData.booking_no }}</span>
                        </li>
                    </ul>
                    </div>

                    <hr />

                    <!-- Patient Info -->
                    <div class="patient-info mb-4">
                    <h6 style="color: #C8102E;"><b> Register Info</b></h6>
                    <ul class="list-unstyled mb-0">
                        
                        <li class="mb-2">
                        <strong>Name :</strong> <span>{{ sideBarApplicantData.name }}</span>
                        </li>
                        <li class="mb-2">
                        <strong>Email Address:</strong> <span>{{ sideBarApplicantData.email }}</span>
                        </li>
                        <li class="mb-2">
                        <strong>Phone Number:</strong> <span>+91 {{ sideBarApplicantData.phoneNumber }}</span>
                        </li>

                    </ul>
                    </div>

                    <hr />

                    <!-- Help / Instruction -->
                    <div class="reschedule-help">
                        <h6 style="color: #C8102E;"><b>How to Add a New Member</b></h6>
                        <ul class="ps-3">
                            <!-- <li>Select your preferred date, time, and slot.</li> -->
                            <li>Complete the payment to proceed.</li>
                            <li>Click <strong>Submit</strong> to confirm.</li>
                        </ul>
                        <!-- <p class="mt-3 small text-muted">
                            <i class="bi bi-exclamation-triangle me-1"></i>
                            You can add a new member only if a slot is currently available. Each booking allows adding members only once.
                        </p> -->
                    </div>


                </div>
            </div>

            <div class="col-lg-9 col-md-8 slot_section p-lg-5 p-4">

                    <div class="container">
                        <h5>Invoice Summary</h5>
                        <p>Review your summary for Slot Booking charge <b style="color: black;">( Non-Refundable )</b>, then continue with the payment process.</p>
                        <div class="invoice-box">
                            <!-- Slot Date Header -->
                            <div class="invoice-header py-4 px-3" style="color: rgb(171 14 14) !important;">
                                Slot Date: 
                                <span class="fw-normal">
                                {{ selectedSlotData ? formatDate(this.selectedSlotData.start_time) : '-' }}
                                </span>
                            </div>
                    
                            <!-- Booking Details -->
                            <div class="row invoice-item px-3 mt-3">
                                <div class="col-6 py-1">
                                <i class="fa-regular fa-clock me-2"></i>Added on
                                </div>
                                <div class="col-6 text-end">
                                {{ formatDate(new Date()) }}
                                </div>
                            </div>
                    
                            <div class="row invoice-item mt-2 px-3">
                                <div class="col-6">
                                <i class="fa-regular fa-clock me-2"></i>Slot Time
                                </div>
                                <div class="col-6 text-end">
                                    {{ selectedSlotData ? formatTimeRange(selectedSlotData.start_time, selectedSlotData.end_time) : '-' }}
                                </div>

                            </div>
                    
                            <hr>
                    
                            <!-- Pricing Details -->
                            <div class="row invoice-item px-3 mt-3">
                                <div class="col-6">
                                <i class="fa-solid fa-person me-2"></i>Adult
                                </div>
                                <div class="col-6 text-end">
                                ₹ {{ selectedSlotData ? this.selectedSlotData.entity_price : 0 }}<br>
                                <small class="text-muted">Count: {{ noOfAdults }}</small>
                                </div>
                            </div>
                    
                            <!-- Children Pricing (conditionally shown) -->
                            <div v-if="noOfChildren > 0">
                                <div class="row invoice-item px-3">
                                <div class="col-6">
                                    <i class="fa-solid fa-child me-2"></i>Children
                                </div>
                                <div class="col-6 text-end">
                                    ₹ {{ selectedSlotData ? this.selectedSlotData.entity_price : 0 }}<br>
                                    <small class="text-muted">Count: {{ noOfChildren }}</small>
                                </div>
                                </div>
                            </div>
                    
                            <hr class="mb-0">
                    
                            <!-- Total Amount -->
                            <div class="row invoice-total py-3 px-2 px-lg-3" style="color: rgb(171 14 14) !important;">
                                <div class="col-6 mb-0">Slot Booking Charge(Non-Refundable)</div>
                                <div class="col-6 text-end">
                                Total : ₹ {{ calculateTotal() }}
                                </div>
                            </div>

                            <!-- <hr class="mb-0"> -->

                            <!-- Instruction Section -->
                            <div class="instruction-box py-3 px-3 mt-2 d-flex align-items-center justify-content-center text-center">
                                <p class="note-text mb-0">
                                    <i class="fa-solid fa-triangle-exclamation me-2" style="color: #ab0e0e !important;"></i>
                                    <i class="fa-solid fa-credit-card me-2" style="color: #ab0e0e;"></i>
                                    Please ensure that your card is enabled for <b>online (E-commerce)</b> transactions.
                                </p>
                            </div>
                            
                        </div>
                    </div>
                
                    <!-- Continue Button -->
                    <div class="row mt-lg-5 pt-lg-2 pt-2">
                        <div class="col-12 col-lg-9 d-flex justify-content-center gap-3">
                            <!-- Back Button (auto size) -->
                            <a href="#" 
                            class="btn btn-secondary px-4 py-2"
                            :disabled="loading"
                            @click="handleBack">
                            Back
                            </a>
                            <a href="#" class="btn continue-btn w-50 px-4 py-2" :disabled="loading" @click="handleContinue">
                                <span v-if="loading"><i class="fa fa-spinner fa-spin"></i> Processing...</span>
                                <span v-else>Continue</span>
                            </a>
                        </div>  
                    </div>

            </div>
        </div>
    </div>

   <Footer />
    <NewMemberVerifyEmailAddressModel v-if="showVerifyEmailModal" @backToSummary="goBackToPaymentSummary" />
  </template>
  
  <script>
  import NewMemberVerifyEmailAddressModel from '@/components/Appointment/Sections/Details/AddNewMember/NewEnailVerify.vue';
  import FormPage from '@/components/Booking/ApplicationForms/Form.vue';
  import Footer from '@/components/Appointment/Layouts/Footer.vue';
  import Header from '@/components/Appointment/Layouts/Header.vue';
  import Swal from 'sweetalert2';
  export default {
    name: "NewMemberPaymentSummary",
    components: {
        NewMemberVerifyEmailAddressModel,
        FormPage,
        Footer,
        Header,
    },
    data() {
      return {
        selectedSlotData: null,
        noOfAdults: null,
        noOfChildren: 0,
        showVerifyEmailModal: false,
        loading: false,
        sideBarApplicantData: {
            booking_no: '',
            phoneNumber: '',
            name: '',
            email: '',
            applicant_name: ''
        },
      };
    },
    mounted() {
        const savedSlot = localStorage.getItem("selectedSlot");
        const applicantData = localStorage.getItem("NewMember_booking_Data");
  
        if (savedSlot) {
            this.selectedSlotData = JSON.parse(savedSlot);
            //console.log("Selected Slot Data:", JSON.stringify(this.selectedSlotData.start_time, 2, null));
            //console.log("Selected Slot Data:", JSON.stringify(this.selectedSlotData.end_time, 2, null));
            //console.log("Selected Slot Data:", JSON.stringify(this.selectedSlotData, 2, null));
            //console.log("Selected Slot Data:", JSON.stringify(JSON.parse(applicantData), 2, null));
        }
  
        if (applicantData) {
            const applicant = JSON.parse(applicantData);
            this.noOfAdults = applicant.noOfAdult || 0;
            // this.noOfChildren = applicant.noOfChildren || 0;
            this.noOfChildren = 0;
        }

        //console.log("this.noOfAdults:", JSON.stringify(JSON.parse(this.noOfAdults), 2, null))

        // REMOVE ANY MODAL BACKDROP LEFTOVER
        document.querySelectorAll('.modal-backdrop').forEach(el => el.remove());

        const resheduleApplicantData = localStorage.getItem('newMmberPaymentApplicantData');
        //console.log('resheduleApplicantData :', JSON.stringify(resheduleApplicantData, null, 2));
        if (resheduleApplicantData) {
          try {
            this.sideBarApplicantData = JSON.parse(resheduleApplicantData);
            //console.log('resheduleApplicantData:1', JSON.stringify(this.sideBarApplicantData, null, 2));
          } catch (error) {
            console.error('Error parsing resheduleApplicantData:', error);
          }
        } else {
          console.warn('No resheduleApplicantData found in localStorage');
        }
    },
    methods: {
        formatDate(dateInput) {
            let date;

            // If input is already a Date object
            if (dateInput instanceof Date) {
                date = dateInput;
            } 
            // If input is a string
            else if (typeof dateInput === 'string') {
                // Replace / with - to ensure reliable parsing
                date = new Date(dateInput.replace(/\//g, '-'));
            } 
            else {
                return '-';
            }

            if (isNaN(date.getTime())) return '-';

            return date.toLocaleDateString('en-US', {
                weekday: 'long',
                year: 'numeric',
                month: 'long',
                day: 'numeric'
            });
        },

        formatTime(datetimeString) {
            if (!datetimeString) return '-';

            // Ensure proper parsing (replace / with -)
            const date = new Date(datetimeString.replace(/\//g, '-'));
            if (isNaN(date.getTime())) return '-';

            return date.toLocaleTimeString('en-US', {
            hour: 'numeric',
            minute: '2-digit',
            hour12: true
            });
        },

        formatTimeRange(start, end) {
            return `${this.formatTime(start)} - ${this.formatTime(end)}`;
        },

        calculateTotal() {
            // const slotPrice = this.selectedSlotData ? this.selectedSlotData.slot_price : 0;
            const slotPrice = this.selectedSlotData ? this.selectedSlotData.entity_price : 0;
            return slotPrice * (this.noOfAdults + this.noOfChildren);
        },

        handleContinue() {
            Swal.fire({
                title: 'Important Notice',
                html: `
                    <div style="
                    text-align:left; 
                    font-size:12px; 
                    line-height:1.5; 
                    color:#212529;
                    background:#f8f9fa; 
                    padding:12px 15px; 
                    border-left:4px solid #d33;
                    border-radius:6px;
                    ">
                    <p><b>If the payment succeeds</b>, you will be redirected to the <span style="color:#0d6efd; font-weight:500;">Application Form</span>.</p>
                    <p>You must <b>complete and submit the form</b> after payment.</p>
                    <p>If the form is not submitted, the process will be considered <span style="color:#d33; font-weight:600;">incomplete</span> and the payment is <span style="color:#d33; font-weight:600;">non-refundable</span>.</p>
                    </div>
                `,
                confirmButtonText: 'I Understand & Proceed',
                confirmButtonColor: 'rgba(199, 29, 34, 1)',
                background: '#ffffff',
                width: 500,
                padding: '1.4em',
                showCloseButton: true,
                allowOutsideClick: true,
                allowEscapeKey: true,
                customClass: {
                    popup: 'rounded-4 shadow-lg',
                    title: 'fw-bold text-dark',
                    confirmButton: 'px-4 py-2 rounded-pill fw-semibold'
                }
                }).then((result) => {
                    if (result.isConfirmed) {
                        //console.log('handleContinue clicked');
                        // Reset first
                        this.showVerifyEmailModal = false;

                        // Wait next tick to force Vue to re-render the modal
                        this.$nextTick(() => {
                            this.showVerifyEmailModal = true;
                        });

                        this.loading = false;
                    }
                });
            
        },

        goBackToPaymentSummary(formData) {
          this.showVerifyEmailModal = false;
          
          //this.$emit("nextStep");
          ///this.$emit("nextStep");
          //console.log("Received Form Number Response Data:", formData);
          this.$toast.success('Payment successful completed.', {
            position: 'top-right',
            duration: 3000,
          });
        },

        handleBack() {
            this.$router.back(); 
        },

    },
  };
  </script>
  